// extracted by mini-css-extract-plugin
module.exports = {"left":"DocumentsStyles_left__1kctT","right":"DocumentsStyles_right__20s_b"};